import { motion } from "framer-motion";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "./LandingPage.scss";
import Header from "./Header";
import Footer from "./Footer";

const HomeLayout: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default HomeLayout;
